const t = {
  name: "TwitterSmall",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_21_2242)">
        <path d="M8.54926 6.00409L17.5174 17.9951H15.4865L6.51838 6.00409H8.54926Z" fill="currentColor"/>
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM10.3438 12.7165L4.57178 18.952H5.87093L10.9244 13.4926L15.0074 18.952H19.4281L13.3694 10.8514L18.742 5.04724H17.4429L12.789 10.0751L9.02868 5.04724H4.60793L10.3438 12.7165Z"
          fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_21_2242">
          <rect width="24" height="24" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>
`
};
export {
  t as TwitterSmall
};
